import React, {useEffect, useRef, useState} from 'react';
import {Card, CardContent} from '@mui/material';
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';

const CATEGORIES = [
	{name: 'Family & friends', question: 'question53'},
	{name: 'Business Angels', question: 'question56'},
	{name: 'Crowdfunding', question: 'question61'},
	{name: 'Incubators and Accelerators', question: 'question66'},
	{name: 'NGO’s loans', question: 'question71'},
	{name: 'NGO’s grants', question: 'question76'},
	{name: 'Public subsidies', question: 'question81'},
	{name: 'Public grants', question: 'question86'},
	{name: 'Venture capital', question: 'question91'},
	{name: 'Microfinance', question: 'question96'},
	{name: 'Financial institutions (banks)', question: 'question101'},
	{name: 'Other', question: 'question106'},
];

const SCALE_MAP = [
	{value: 'SCALE _DWT_T1_100', text: '76 - 100%', color: '#38761d'},
	{value: 'SCALE _DWT_T1_75', text: '51 - 75%', color: '#6aa84f'},
	{value: 'SCALE _DWT_T1_50', text: '26 - 50%', color: '#93c47d'},
	{value: 'SCALE _DWT_T1_25', text: '6 - 25%', color: '#b6d7a8'},
	{value: 'SCALE _DWT_T1_5', text: '0 – 5 %', color: '#d9ead3'},
];

interface Props {
	final: any[];
}

const ProgramContribution = ({final}: Props) => {
	const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
	const [options, setOptions] = useState<Highcharts.Options>();

	const calculateSubmissions = () => {
		const seriesData: Highcharts.SeriesColumnOptions[] = SCALE_MAP.map((scale) => {
			const data = CATEGORIES.map((category) => {
				const answers = final
					.flatMap((submission: any) =>
						Object.keys(submission)
							.filter((k) => k.startsWith(category.question))
							.map((k) => submission[k])
							.filter(Boolean)
					);

				const totalAnswers = answers.length || 1
				const count = answers.filter((ans) => ans === scale.value).length;

				return Number(((count / totalAnswers) * 100).toFixed(1));
			});

			return {
				type: 'column' as const,
				name: scale.text,
				data,
				color: scale.color,
			};
		});

		setOptions({
			chart: {type: 'column'},
			title: {text: 'E4I Program contribution to access funds', align: 'left'},
			xAxis: {categories: CATEGORIES.map((c) => c.name)},
			yAxis: {min: 0, max: 100, title: {text: '%'}},
			legend: {verticalAlign: 'bottom'},
			plotOptions: {
				column: {stacking: 'normal', dataLabels: {enabled: false}},
			},
			series: seriesData,
		});
	};

	useEffect(() => {
		calculateSubmissions();
	}, [final]);

	return (
		<Card className='chart-container'>
			<CardContent>
				{options && <HighchartsReact highcharts={Highcharts} options={options} ref={chartComponentRef} />}
			</CardContent>
		</Card>
	);
};

export default ProgramContribution;